import { render, staticRenderFns } from "./Invoices.html?vue&type=template&id=54be8f4f&external"
import script from "./Invoices.js?vue&type=script&lang=js&external"
export * from "./Invoices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports